import { createGlobalStyle } from "styled-components";

export const FixedStyle = createGlobalStyle`

.zoom-icon {
  color: ${({ theme }) => theme.primary};
  width: 24px;
  height: 24px;
}

.zoom-icon-wrapper {
  display: none;
  transition: right .5s;
}

.bfc-fixed {
  .Preview {
    @media (min-width: 768px) {
    top: 100px;
  }
  }
  .PartImage {
    @media (max-width: 767px) {
      width: ${(props) => (props.zoomedIn ? "80%" : "40%")};
      margin-top: 10px;
    }
  }
  .zoom-icon,
  .zoom-icon-wrapper 
  {
    @media (max-width: 767px) {
      position: absolute;
      display: block;
      right: ${(props) => (props.zoomedIn ? "5%" : "20%")};
      top: 15px;
    }
  }
}
`;
